(function(){
    'use strict'

    angular.module('app.departamentos')
    .factory('DepartamentosService', DepartamentosService);

    DepartamentosService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function DepartamentosService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/departamentos/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, departamentoId){

            var url = apiSettings.apiBaseUrl + 'api/departamentos/' + companiaId + '/' + departamentoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(departamento){

            departamento.id = 0;
            departamento.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/departamentos',  
                method: 'POST',  
                data: departamento
            });  
            return response;
        };

        function update(departamento){

            departamento.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/departamentos',  
                method: 'PUT',  
                data: departamento
            });  
            return response;
        };

        function remove(departamento){

            departamento.companiaId = UserInfoService.getCompaniaId();
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/departamentos',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: departamento
            });  
            return response;
        };

    };

})();